/**
 * Remove null or undefined keys from object
 * @param obj
 */
export function removeNullKeys<T extends Record<string, unknown>>(obj: T) {
  return removeKeys(obj, (x) => x === undefined || x === null) as {
    [K in keyof Required<T>]: NonNullable<T[K]>;
  };
}

export function removeKeys<T extends Record<string, unknown>>(
  obj: T,
  predicate: (value: unknown) => boolean
) {
  Object.keys(obj).forEach((key) => {
    if (predicate(obj[key])) {
      delete obj[key];
    }
  });
  return obj;
}
